import { render, staticRenderFns } from "./introduce.vue?vue&type=template&id=90c0aa94&scoped=true&"
var script = {}
import style0 from "./introduce.vue?vue&type=style&index=0&id=90c0aa94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c0aa94",
  null
  
)

export default component.exports